export enum EFileType {
  CSV = 'CSV',
  EXCEL = 'EXCEL',
  PDF = 'PDF'
}
